import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { forkJoin } from 'rxjs';

import { AbstractService } from '../../../services/abstract.service';
import { AccountService } from '../../../services/account.service';
import { AuthService } from '../../../services/auth.service';
import { TeamService } from '../../../services/team.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { ErrorService } from '../../../services/error.service';
import { Utilities } from '../../../services/utilities';

import { Roles, TeamType } from '../../../models/enums';
import { OptionsByRole } from '../options-by-role';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-action-menu',
  templateUrl: './action-menu.component.html',
  styleUrls: ['./action-menu.component.css'],
  imports: [
    MatButtonModule,
    CommonModule,
    RouterModule,
  ]
})
export class ActionMenuComponent implements OnInit, AfterViewChecked {
  errorFromRedirect: any;
  canUserCode: boolean;
  userCannotCodeMessage = 'There are no abstracts to code at this time.';
  menu: {
    role: Roles;
    title: string;
    options: { title: string; url: string; inActionMenu: boolean; parameters?: object }[];
  };

  uncodedAbstracts = -1;
  isLoadingResults = true;
  loadingIndicator = false;

  doDisplay = false;
  hasDisplayed = false;

  constructor(
    public router: Router,
    private abstractService: AbstractService,
    private accountService: AccountService,
    private authService: AuthService,
    private teamService: TeamService,
    private alertService: AlertService,
    private errorService: ErrorService,
  ) { }

  ngOnInit() {
    if (this.authService.isSessionExpired) {
      this.router.navigateByUrl('/account/login');
      return;
    }

    const activeRole = this.accountService.GetActiveRole();
    const activeTeam = this.accountService.GetActiveTeam();
    this.menu = OptionsByRole.find(opt => opt.role === activeRole);

    console.log("before role check");
    //if (activeRole === Roles.Coder || activeRole === Roles.Supervisor) supervisor role can no longer code
    if (activeRole === Roles.QCCoder) {
      console.log("active team res");
      console.log(activeTeam);
      this.checkIfUserCanCode(activeRole, activeTeam == null ? 0 : activeTeam.teamId);
    }
  }

  ngAfterViewChecked() {
    if (this.doDisplay && !this.hasDisplayed) {
      this.hasDisplayed = true;

      if (!this.errorFromRedirect) {
        this.errorFromRedirect = this.errorService.error;
      }

      if (this.errorFromRedirect) {
        this.alertService.resetStickyMessage();
        this.alertService.showStickyMessage(
          this.errorFromRedirect.title, this.errorFromRedirect.message, this.errorFromRedirect.severity, this.errorFromRedirect.error);
      }
    }

    if (!this.doDisplay) {
      this.doDisplay = true;
    }
  }

  checkIfUserCanCode(activeRole: Roles, activeTeam: number) {
    this.alertService.startLoadingMessage();
    this.isLoadingResults = true;

    const teamType = this.teamService.getTeamTypeFromRole(activeRole);

    forkJoin([this.abstractService.getUncodedAbstractsCount(activeRole, activeTeam), this.teamService.isUserInTeam(teamType)])
      .subscribe({
        next: ([abstractCount, isUserInTeam]) => {
        this.alertService.stopLoadingMessage();
        this.loadingIndicator = false;
        this.isLoadingResults = false;

        this.uncodedAbstracts = activeRole === Roles.QCSupervisor || activeRole === Roles.QCCoder ? abstractCount : -1;
        this.canUserCode = abstractCount > 0 && isUserInTeam;
        this.userCannotCodeMessage = !isUserInTeam
          ? 'You have not been added to a team at this time. Once you are on a team, refresh this page and you can begin.'
          : 'There are no abstracts to code at this time.';

      }, error: (error) => {
        this.alertService.stopLoadingMessage();
        this.loadingIndicator = false;
        this.alertService.showStickyMessage('Load Error',
          `Unable to retrieve data from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
          MessageSeverity.error, error);
      }});
  }
}
